import { VydejMenu } from '../../vydej/vydejmenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';
import { PublishsetList } from '../../publishsets/components/PublishsetList';

const VydejPublishsetListPage = () => {
  const { apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.vydej ? (
        <AppWrapper
          appType={APP_TYPE.VYDEJ}
          menu={<VydejMenu />}
          resource='Publishsets'
          action='list.view'
        >
          <PublishsetList />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default VydejPublishsetListPage;
